import { sanitizeRedirect } from '@/utils/redirect';

interface ResolveSignInRedirectParams {
  redirect: string;
  hasOrganization: boolean;
}

interface ResolveSignInRedirectResult {
  route: string;
  pendingRedirect: string | null;
}

export const resolveSignInRedirect = ({
  redirect,
  hasOrganization,
}: ResolveSignInRedirectParams): ResolveSignInRedirectResult => {
  const nextRedirect = sanitizeRedirect(redirect) ?? '/';

  if (hasOrganization) {
    return {
      route: nextRedirect,
      pendingRedirect: null,
    };
  }

  return {
    route: '/onboarding',
    pendingRedirect: nextRedirect,
  };
};

export const resolveOnboardingRedirect = (
  pendingRedirect?: string | null,
): string => sanitizeRedirect(pendingRedirect) ?? '/';
